import { type ForwardedRef, forwardRef } from 'react';

/**
 * 客服耳机图标（24x24）。
 * 用于「我的订阅」页右下角的浮动联系入口等场景。
 */
export const BaseLineCustomerService = forwardRef(
  (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>, ref: ForwardedRef<SVGSVGElement>) => (
    <svg
      width="1em"
      height="1em"
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path d="M4 14v-1.5a8 8 0 0 1 16 0V14" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
      <path
        d="M3.75 15a1.25 1.25 0 0 1 1.25-1.25h1.25A1.25 1.25 0 0 1 7.5 15v3.75A1.25 1.25 0 0 1 6.25 20H5A1.25 1.25 0 0 1 3.75 18.75z"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M16.5 15a1.25 1.25 0 0 1 1.25-1.25H19A1.25 1.25 0 0 1 20.25 15v3.75A1.25 1.25 0 0 1 19 20h-1.25A1.25 1.25 0 0 1 16.5 18.75z"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path d="M17.75 20v.5a2 2 0 0 1-2 2H13.5" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
    </svg>
  ),
);

BaseLineCustomerService.displayName = 'BaseLineCustomerService';
